@if (isShowNotification) {
  <div class="notification">
    @for (notification of notifyArray; track notification) {
      <div
        class="notification-item"
        [ngClass]="{
          'notification-item--success': notification?.severity === 'success',
          'notification-item--error': notification?.severity === 'error'
        }"
      >
        <div class="notification__content">
          <div
            [ngClass]="{
              'btv-icon-circle-success': notification?.severity === 'success' || notification?.severity === 'info',
              'btv-icon-circle-close': notification?.severity === 'error'
            }"
          ></div>
          <p>{{ notification?.message }}</p>
        </div>
        <span class="btv-icon-close" (click)="closeNotification(notification?.id)"></span>
      </div>
    }
  </div>
}
